import React, { useEffect, useState } from "react";
import "./payment.css";
import TypingAnimation from "./TypingAnimation";
import { useDispatch, useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import {
  actions,
  getPaymentDetails,
  getPreloader,
} from "../redux/main-reducer";
import axios from "axios";
import Vector from "../../images/Vector.png";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import buttonLoader from "../../images/button-loader.svg";
import { attachImageUrl } from "../../utils/attachImageUrl";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#171717",
    color: "#FFFFFF",
    fontSize: "12px",
    top: "5px",
  },
}));

const OTP_LENGTH = 6;

function PhoneNumberPayment({ isShowForm, onShowForm, setCommonErrorMessage }) {
  const preloader = useSelector(getPreloader);
  const paymentDetails = useSelector(getPaymentDetails);
  const searchParams = new URLSearchParams(window.location.search);
  const isInvType = searchParams.get("inv_type") === "4";
  const cardRef = React.useRef(null);
  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(""));
  const inputRefs = React.useRef([]);

  const dispatch = useDispatch();

  const API_ROOT = process.env.REACT_APP_API_ROOT;

  const [phoneNumber, setPhoneNumber] = useState("998");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [smsVerificationState, setSmsVerificationState] = useState(false);
  const [smsVerification, setSmsVerification] = useState("");
  const [resendTimer, setResendTimer] = useState(59);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorCardMessage, setErrorCardMessage] = useState("");
  const [isErrorCardType, setIsErrorCardType] = useState(false);
  const [errorMessageSMS, setErrorMessageSMS] = useState("");
  const [payID, setPayID] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedOption, setSelectedOption] = useState("UZCARD");
  const [rawPhone, setRawPhone] = useState("");
  const [formattedPhone, setFormattedPhone] = useState("");
  const [showExpiryFields, setShowExpiryFields] = useState(false);

  const handlePhoneChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "").slice(0, 9);
    const formatted = formatPhoneNumber(raw);

    setRawPhone(raw);
    setFormattedPhone(formatted);

    if (raw?.length === 9 && !showExpiryFields) {
      setShowExpiryFields(true);
      return;
    }

    if (raw?.length === 9 && showExpiryFields) {
      cardRef.current?.focus();
    }
  };

  const formatPhoneNumber = (value) => {
    const numbers = value.replace(/\D/g, "").slice(0, 9);
    const parts = [];

    if (numbers.length > 0) parts.push(numbers.slice(0, 2));
    if (numbers.length > 2) parts.push(numbers.slice(2, 5));
    if (numbers.length > 5) parts.push(numbers.slice(5, 7));
    if (numbers.length > 7) parts.push(numbers.slice(7, 9));

    return parts.join(" ");
  };

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const isFormValid =
    phoneNumber &&
    phoneNumber?.length === 12 &&
    cardNumber &&
    cardNumber?.length === 4;
  const isSmsValid = /^\d{6}$/.test(smsVerification);

  useEffect(() => {
    let timer;
    if (isTimerActive && resendTimer > 0) {
      timer = setTimeout(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0) {
      setIsTimerActive(false);
    }
    return () => clearTimeout(timer);
  }, [resendTimer, isTimerActive]);

  useEffect(() => {
    if (showExpiryFields && cardRef.current) {
      cardRef.current.focus();
    }
  }, [showExpiryFields]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setCommonErrorMessage("");
    setErrorCardMessage("");
    setIsSubmitting(true);

    try {
      const key = new URLSearchParams(window.location.search).get("key");

      console.log(rawPhone);
      console.log(cardNumber);

      if (!rawPhone) {
        setErrorMessage("Введите номер телефона");
        return;
      }

      if (rawPhone?.length < 9) {
        setErrorMessage("Номер телефона должен содержать 12 цифр");
        return;
      }

      if (!cardNumber) {
        setErrorCardMessage("Введите последние 4 цифры карты");
        return;
      }

      if (cardNumber?.length < 4) {
        setErrorCardMessage("Номер должен содержать последние 4 цифры карты");
        return;
      }

      const data = {
        phone_number: `998${rawPhone}`,
        card_number: cardNumber,
        key: key,
        is_by_phone: true,
      };

      if (isErrorCardType) {
        data.ps_code = selectedOption;
      }

      const response = await axios.post(
        `${API_ROOT}/api/v1/ecomm/payments/pay/create`,
        data
      );

      setPayID(response?.data?.data?.pay_id);
      console.log(response?.data?.data?.pay_id);

      if (response.data && response.data.status === "Success") {
        setSmsVerificationState(true);
        onShowForm(true);
        setResendTimer(59);
        console.log(response?.data);
        setIsTimerActive(true);
      } else {
        throw new Error(
          response.data.error_note || "Не удалось инициировать оплату"
        );
      }
    } catch (error) {
      console.error("Error during payment request:", error);
      if (error.response?.data?.error_code === 1002) {
        setErrorCardMessage("Карта не найдена");
      } else if (error.response?.data?.error_code === 1001) {
        setErrorCardMessage("На вашей карте недостаточно средств");
      } else if (error.response?.data?.error_code === 1034) {
        setErrorCardMessage("Карта не активна");
      } else if (error.response?.data?.error_code === 1021) {
        setErrorCardMessage("Срок действия карты истек");
      } else if (error.response?.data?.error_code === 1024) {
        setErrorCardMessage("Срок действия карты указан неверно");
      } else if (error.response?.data?.error_code === 1063) {
        setErrorCardMessage(true);
      } else if (isInvType && error.response?.data?.error_code === 1056) {
        window.location.replace(`${paymentDetails?.failure_url}`);
      } else {
        setCommonErrorMessage(error?.response?.data?.error_note || "Произошла ошибка. Пожалуйста, попробуйте позже");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleVerification = async (otpCode) => {
    if (!/^[a-zA-Z0-9]{6}$/.test(otpCode)) {
      console.warn("OTP невалиден");
      return;
    }

    setErrorMessage("");
    setCommonErrorMessage("");
    setErrorCardMessage("");

    // e.preventDefault();

    try {
      dispatch(actions.setPreloader(true));

      const data = {
        confirm_code: otpCode,
        pay_id: payID,
      };

      const response = await axios.post(
        `${API_ROOT}/api/v1/ecomm/payments/pay/confirm`,
        data
      );

      console.log("SMS Verification Success:", response);

      if (response.data && response.data.status === "Success") {
        dispatch(actions.setPaymentDetails(attachImageUrl(response?.data?.data)));
        console.log(response?.data?.data);
        // window.location.replace(`${paymentDetails?.success_url}`);
        setTimeout(() => {
          dispatch(actions.setPaymentState(true));
          dispatch(actions.setPreloader(false));
          dispatch(actions.setPaymentDetails(attachImageUrl(response?.data?.data)));
        }, 1000);
      } else {
        throw new Error(
          response.data.error_note || "Не удалось подтвердить оплату"
        );
      }
    } catch (error) {
      console.error("Error during SMS verification:", error);
      if (error.response?.data?.error_code === 1008) {
        setErrorMessageSMS("Введенный SMS-код не верный");
      } else if (error.response?.data?.error_code === 1027) {
        setErrorMessageSMS(
          "Карта заблокирована. Попробуйте снова через 5 минут"
        );
      } else if (error.response?.data?.error_code === 1028) {
        setErrorMessageSMS(
          "Карта заблокирована. Попробуйте снова через 5 минут"
        );
      } else if (error.response?.data?.error_code === 1029) {
        setErrorMessageSMS(
          "Повторно запросить SMS-код можно только через 1 минуту."
        );
      } else if (error.response?.data?.error_code === 1030) {
        setErrorMessageSMS(
          "Срок действия кода подтверждения платежа истёк. Код действителен в течение 1 минуты"
        );
      } else if (error.response?.data?.error_code === 1031) {
        setErrorMessageSMS("Время повторной отправки SMS истекло.");
      } else if (error.response?.data?.error_code === 1004) {
        setErrorMessageSMS(
          "Функция отправки SMS-кода не работает. Пожалуйста попробуйте позже"
        );
      } else if (error.response?.data?.error_code === 1058) {
        setErrorMessageSMS(
          "SMS уже было отправлено. Пожалуйста, попробуйте снова через 1 минуту."
        );
      } else if (isInvType) {
        window.location.replace(`${paymentDetails?.failure_url}`);
        setErrorMessageSMS("Ошибка проверки SMS-кода");
      } else {
        setErrorMessageSMS("Ошибка проверки SMS-кода");
      }
      dispatch(actions.setPreloader(false));
    }
  };

  const handleResend = async () => {
    setErrorMessage("");
    setCommonErrorMessage("");
    setErrorCardMessage("");
    setResendTimer(59);
    setIsTimerActive(true);

    try {
      const data = {
        pay_id: payID,
      };

      const response = await axios.post(
        `${API_ROOT}/api/v1/ecomm/payments/pay/sms/resend`,
        data
      );

      console.log("SMS Resend Response:", response);

      if (response.data && response.data.status === "Success") {
        console.log("SMS code resent successfully");
      } else {
        throw new Error(
          response.data.error_note || "Не удалось повторно отправить код"
        );
      }
    } catch (error) {
      console.error("Error during SMS resend:", error);
      setErrorMessage(error.message || "Ошибка повторной отправки СМС-кода");
      setIsTimerActive(false);
    }
  };

  // const handlePhoneNumberChange = (e) => {
  //   let value = e.target.value.replace(/\D/g, ""); // удаляем все нецифры

  //   // Если пользователь полностью очистил поле, оставляем "998"
  //   if (value.length < 3) {
  //     value = "998";
  //   }

  //   // Максимум 12 символов (998 + 9 цифр)
  //   value = "998" + value.slice(3, 12);

  //   setPhoneNumber(value);
  // };

  const handleCardNumberChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // удаляем все нецифры

    // Максимум 12 символов (998 + 9 цифр)
    value = value.slice(0, 4);

    setCardNumber(value);
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value[0]; // Вставляем только первую цифру
    setOtp(newOtp);

    // Перейти к следующему полю
    if (index < OTP_LENGTH - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    // Отправка только когда все 6 полей заполнены
    const otpComplete = newOtp.every((val) => val.length === 1);
    if (otpComplete) {
      const otpCode = newOtp.join("");
      handleVerification(otpCode);
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData
      .getData("Text")
      .replace(/[^a-zA-Z0-9]/g, "");

    if (pasteData.length === OTP_LENGTH) {
      const newOtp = pasteData.split("").slice(0, OTP_LENGTH);
      setOtp(newOtp);

      // автофокус на последнем
      inputRefs.current[OTP_LENGTH - 1]?.focus();

      // автоотправка
      handleVerification(newOtp.join(""));
    }

    e.preventDefault(); // предотвратить вставку в одно поле
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (otp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  console.log("PaymentDetails", paymentDetails);

  return (
    <div className="payment-container">
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        <div className={`payment-container-info ${preloader ? "blur" : ""}`}>
          {!isShowForm && (
            <form className="payment-form" onSubmit={handleSubmit}>
              <div className="payment-fields-block">
                <div className="form-group">
                  <div className="form-group-label">
                    Номер телефона
                    <BootstrapTooltip
                      placement="top"
                      title="Введите номер, к которому привязаны ваши банковские карты"
                    >
                      <img className="form-group-img" src={Vector} alt="" />
                    </BootstrapTooltip>
                  </div>
                  <div className="phone-input-container">
                    <span className="phone-prefix">+998</span>
                    <input
                      type="text"
                      value={formattedPhone}
                      onChange={handlePhoneChange}
                      placeholder="91 829 79 69"
                      maxLength={12}
                      disabled={isSubmitting}
                      className={`phone-input ${
                        errorMessage && "phone-input_error"
                      }`}
                    />
                  </div>
                  {errorMessage && (
                    <div className="error-message">{errorMessage}</div>
                  )}
                </div>
                {showExpiryFields && (
                  <div className="form-group">
                    <div className="form-group-label">
                      Последние 4 цифры карты{" "}
                      <BootstrapTooltip
                        placement="top"
                        title="Введите последние 4 цифры карты, которая привязана к этому номеру. С нее спишутся деньги"
                      >
                        <img className="form-group-img" src={Vector} alt="" />
                      </BootstrapTooltip>
                    </div>
                    <input
                      ref={cardRef}
                      type="text"
                      value={cardNumber}
                      onChange={handleCardNumberChange}
                      placeholder="**** **** **** 2353"
                      maxLength="4"
                      disabled={isSubmitting}
                      className={`input-field-shord-card ${
                        errorCardMessage && "phone-input_error"
                      }`}
                    />
                    {errorCardMessage && (
                      <div className="error-message">{errorCardMessage}</div>
                    )}
                  </div>
                )}
              </div>
              {isErrorCardType && (
                <div className="form-group">
                  <h3 className="form-group__text">Выберите тип карты:</h3>
                  <div className="radio-group">
                    <div>
                      <input
                        type="radio"
                        value="UZCARD"
                        checked={selectedOption === "UZCARD"}
                        onChange={handleChange}
                      />
                      &nbsp;UZCARD
                    </div>

                    <div>
                      <input
                        type="radio"
                        value="HUMO"
                        checked={selectedOption === "HUMO"}
                        onChange={handleChange}
                      />
                      &nbsp;HUMO
                    </div>
                  </div>
                </div>
              )}
              <button
                className={`pay-button ${isSubmitting ? "_disable" : ""}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <div className="button-loader">
                    <img
                      className="button-loader__image"
                      src={buttonLoader}
                      alt=""
                    />
                  </div>
                ) : (
                  "Оплатить"
                )}
              </button>
            </form>
          )}
          {smsVerificationState && isShowForm && (
            <>
              {/* <form className="payment-form" onSubmit={handleVerification}> */}
              {/* <div className="form-group">
                <input
                  type="text"
                  value={smsVerification}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setSmsVerification(value.slice(0, 6));
                  }}
                  placeholder=" "
                  maxLength="6"
                  className="input-field"
                />
                <label>СМС код</label>
                {errorMessageSMS && (
                  <div className="error-message">{errorMessageSMS}</div>
                )}
              </div> */}
              <div className="otp-wrapper">
                <div className="otp-wrapper__block">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      inputMode="text"
                      maxLength={1}
                      className={`otp-input ${
                        errorMessageSMS && "otp-input_error"
                      }`}
                      value={digit}
                      onChange={(e) => handleOtpChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      onPaste={handlePaste}
                      ref={(el) => {
                        if (el) inputRefs.current[index] = el;
                      }}
                    />
                  ))}
                </div>
                {errorMessageSMS && (
                  <div className="error-message">{errorMessageSMS}</div>
                )}
              </div>
              {isTimerActive ? (
                <div className="resend-sms">
                  Отправим код повторно через{" "}
                  {resendTimer.toString().padStart(2, "0")} секунд
                </div>
              ) : (
                <div className="resend-sms" onClick={handleResend}>
                  Отправить СМС повторно
                </div>
              )}
              <div
                className="resend-sms _m-t-4"
                onClick={() => onShowForm(false)}
              >
                Вернуться назад
              </div>
            </>
          )}
        </div>
        {isInvType && !isShowForm && (
          <button
            type="button"
            className="download-button"
            onClick={() =>
              window.location.replace(`${paymentDetails?.failure_url}`)
            }
          >
            Закрыть
          </button>
        )}
      </div>
      {preloader && (
        <div className="loader">
          <div className="loading"></div>
          <div className="typing-container">
            <TypingAnimation
              texts={["Идёт оплата...", "Не закрывайте страницу..."]}
              typingInterval={70}
              pauseDuration={1000}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default PhoneNumberPayment;
